import {FormControl, IconButton, Textarea} from '@primer/react'
import {ScreenFullIcon} from '@primer/octicons-react'
import {clsx} from 'clsx'

import styles from './ConfigSections.module.css'

type PromptSectionProps = {
  prompt: string
  onChange: (prompt: string) => void
  showValidation: boolean
  isExpanded: boolean
  onToggleExpand: () => void
}

export function PromptSection({prompt, onChange, showValidation, isExpanded, onToggleExpand}: PromptSectionProps) {
  return (
    <div className={clsx(styles.section, isExpanded && styles.sectionExpanded)}>
      {!isExpanded && (
        <div className={styles.sectionHeaderRow}>
          <div className={styles.sectionHeaderText}>
            <h3 className={styles.sectionTitle}>Prompt</h3>
            <p className={styles.sectionSubtitle}>High-level instructions — set overall goals, tone, and guardrails.</p>
          </div>
          <IconButton
            icon={ScreenFullIcon}
            aria-label="Expand prompt"
            variant="invisible"
            size="small"
            onClick={onToggleExpand}
            data-testid="prompt-expand-button"
          />
        </div>
      )}
      {isExpanded && (
        <div className={styles.sectionHeaderRow}>
          <div className={styles.sectionHeaderText}>
            <p className={styles.sectionSubtitle}>High-level instructions — set overall goals, tone, and guardrails.</p>
          </div>
        </div>
      )}

      {showValidation && !prompt.trim() && <p className={styles.validationError}>Prompt instructions are required.</p>}

      <FormControl>
        <FormControl.Label visuallyHidden>Prompt instructions</FormControl.Label>
        <Textarea
          className={clsx(styles.promptTextarea, isExpanded && styles.promptTextareaExpanded)}
          rows={isExpanded ? 25 : 7}
          value={prompt}
          onChange={e => onChange(e.target.value)}
          aria-label="Prompt instructions"
          data-testid="prompt-textarea"
          resize="none"
          block
        />
      </FormControl>
    </div>
  )
}
